const dateFormatHelper = (date: Date) => {
	const newDate = new Date(date)
	const formatted = `${String(newDate.getDate()).padStart(2, '0')}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${newDate.getFullYear()}`
	return formatted
}

export default dateFormatHelper